import { render, staticRenderFns } from "./orderAddressKeywords.vue?vue&type=template&id=2c91d876&scoped=true"
import script from "./orderAddressKeywords.vue?vue&type=script&lang=js"
export * from "./orderAddressKeywords.vue?vue&type=script&lang=js"
import style0 from "./orderAddressKeywords.vue?vue&type=style&index=0&id=2c91d876&prod&scoped=true&lang=css"
import style1 from "./orderAddressKeywords.vue?vue&type=style&index=1&id=2c91d876&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c91d876",
  null
  
)

export default component.exports